import { styled, darken } from '@mui/material/styles';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';

export const BarProgress = styled(LinearProgress)(({
  theme,
  color,
  width,
  height,
}) => {
  const baseColor = color || theme.palette.primary.main;

  const lighterColor = darken(baseColor, 0.2);

  return {
    width: width ? width : '100%',
    height: height ? height : 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.root}`]: {
      backgroundColor: theme.palette.grey['05'] || '#f0f0f0',
    },
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey['06'],
      ...theme.applyStyles('dark', {
        backgroundColor: theme.palette.grey['06'],
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      background: `linear-gradient(90deg, ${baseColor} 0%, ${lighterColor} 100%)`,

      ...theme.applyStyles('dark', {
        background: `linear-gradient(90deg, ${baseColor} 0%, ${lighterColor} 100%)`,
      }),
    },
  };
});

export const StatsBoxContainer = styled(Stack)`
  margin-top: 2;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
`;

interface NumberContainerProps {
  color: string;
}

export const NumberContainer = styled(Typography)<NumberContainerProps>`
  font-weight: 700;
  color: ${({ color }) => color};
  display: flex;
  align-items: flex-end;
  line-height: 1;
  font-size: 36;
`;

export const BarProgressContainer = styled(Stack)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 2;
`;
